/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {UserService} from '../services/user.service';
import {Permission} from '../utils/permission.enum';

@Component({
    selector: 'app-wizard-footer',
    templateUrl: './wizard-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WizardFooterComponent implements OnInit {
    @Output() saveAction = new EventEmitter<any>();
    @Output() finishAction = new EventEmitter<any>();
    @Output() sendAction = new EventEmitter<any>();
    @Output() closeAction = new EventEmitter<any>();
    @Output() discardAction = new EventEmitter<any>();

    @Output() continue = new EventEmitter<any>();
    @Output() back = new EventEmitter<any>();

    @Input() finishBtn: boolean;
    @Input() backBtn: boolean;
    @Input() sendBtn: boolean;
    @Input() closeBtn: boolean;

    @Input() disableSend: boolean;
    @Input() disableContinue: boolean;
    @Input() disableSave: boolean;

    public Permission = Permission;

    constructor(public userService: UserService) {
    }

    ngOnInit(): void {
    }

    discard(): void {
        this.discardAction.emit();
    }

    save(): void {
        this.saveAction.emit();
    }

    finish(): void {
        this.finishAction.emit();
    }

    continueClick(): void {
        this.continue.emit();
    }

    backClick(): void {
        this.back.emit();
    }

    sendClick(): void {
        this.sendAction.emit();
    }

    closeClick(): void {
        this.closeAction.emit();
    }
}
